<template>

    <section class="blog_item_section">
        <div class="container">
			
            <div class="col">
                    <img src="@/./assets/website/img/success.png" style="display: block; margin-left: auto; margin-right: auto; max-width: 210px;">
                    <h1 class="title text-center">Payment Succesfully Done!</h1>
					<div>
                    <span class="include text-center">Order Id: {{this.order_id}} </span>
                    <span class="include text-center">Amount: {{this.grand_total}} </span>
                    </div>
					<span class="include text-center">Thank you for ordering for us!!</span>
					
                </div> 
                <br/>
						
			<div class="row">
				<div class="col-md-12 text-center">
					<button type="button" v-on:click="OrderSummary();" class="genric-btn danger circle mb-3" style="font-size:15px; box-shadow: 2px 2px 7px #a7a7a7;">
                    Browse Menu
                    </button>
				</div>
			</div>
			<br/>
			<br/>
			<br/>
        </div>
    </section>
</template>


<script>

import "@meforma/vue-toaster";
export default {
  name: 'PaymentFail',
  data: function (){
    return {
      tax_calculation:[],
      grand_total: null,
      items: [],
      service_fee_amount: null,
      created_at: null,
      order_id: null,
      restaurant_id:null,
      table_id:null,
      currency:null,
      lang: "",
      eng_lang: false,
      thai_lang: false,
      jap_lang: false,
      ko_lang: false,
      it_lang: false,
      ch_lang: false,
      ro_lang: false,
      html_data: '',
      encRequest: '',
      access_code: '',
      x: 'online',

      
    }
  },
  methods : {
    
        OrderSummary: function(){
            this.$router.push('/restaurant/menu/'+this.restaurant_id+'/'+this.table_id);
        },

  },
  mounted: function(){
    // if(!localStorage.getItem('session_id')){
    //       this.$router.push('/pagenotfound/');
    //   }

      var session_id = localStorage.getItem('session_id');
      var restaurant_id = localStorage.getItem('restaurant_id');
      var table_id = localStorage.getItem('table_id');
      var currency = localStorage.getItem('currency');
      var lang = localStorage.getItem('lang');
      this.logo = localStorage.getItem('logo');
      this.order_id = localStorage.getItem('order_id');
      this.grand_total = localStorage.getItem('grand_total');
      this.restaurant_id = restaurant_id;
      this.table_id = table_id;
      this.session_id = session_id;
      this.currency = currency;
      this.lang = lang;
    
  }
}
</script>

<style>
	p{
		font-family: Okra,Helvetica,sans-serif !important;
	}
	.tag{
	height: max-content;
    width: max-content;
    background: #ff376e;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    border-radius: 5px;
    color: rgb(255, 255, 255);
    font-size: 0.66rem;
    border: none;
    padding: 0.2rem 0.2rem;
    letter-spacing: 1px;
	}
	.title{
    line-height: 1.2;
    font-weight:bold;
    font-size: 23px;
    color: #ff0000;
	}
	.include{
		font-size: 15px;
		color: #6c6c6c;
		display:block;
	}
	.item{
		border-radius: 5px;
	}
	.price{
	font-weight: bold;
	}
	span {cursor:pointer; }
    .number{
        background: #ffeef5;
        text-align: center;
        border-radius: 5px;
        position: relative;
        
        border: 2px solid #ff5f8b;
    }

    input{
        height:20px;
        width:22px;
        text-align: center;
        font-size: 13px;
        background: #ffeef5;
        border: 1px solid #ffeef5;		
        display: inline-block;
        vertical-align: middle;
    }
    hr {
        margin-top: 0.40rem;
        margin-bottom: 1rem;
        border: 0;
        border-top: 1px solid rgba(223 220 220 / 70);
    }
    .menu-title{
    font-size: 17px;;
    line-height: 1;
    padding: 1rem 0px;
    color: #000;
    margin: 0px;
    margin-block-end: 0px;
    position: sticky;
    top: 106px;
    font-weight:bold;
    z-index: 1;
    display: flex;
    }
    .bgc{
        background: #f7f7f7;
    }
    .bgcb{
        background: #f7f7f7;
        padding-bottom: 19px;
    }
    .thead-light{
        color: #495057;
        background-color: #e9ecef;
        border-color: #dee2e6;
		}
	</style>